<template>
  <div class="pad-top-25 pad-btm-20 ps-re">
    <section class="crumbs-container">
      <span v-for="(item, index) in ancestors" :key="`${item.name}-${index}`" :class="{'active': index === ancestors.length - 1 }">
        <router-link :to="{'name': 'Index'}" v-if="item.name === '首页'">{{item.name}}</router-link>
        <span v-else-if="!ancestors[0].categoryId || (index === ancestors.length - 1)">{{item.name}}</span>
        <router-link :to="{'name': page == 'NoticeDetail' ? 'Notice' : page == 'Detail' ? 'Rule' : page, 'query': {'categoryId': ancestors[0].categoryId}}" v-else-if="index === 0">{{item.name}}</router-link>
        <router-link :to="{'name': page == 'NoticeDetail' ? 'Notice' : page == 'Detail' ? 'Rule' : page, 'query': {'categoryId': ancestors[0].categoryId, 'childCategoryId': item.categoryId}}" v-else>{{item.name}}</router-link>
        <span v-if="index !== ancestors.length - 1"> &gt; </span>
      </span>
    </section>
  </div>
</template>

<script>
import {mapState} from 'vuex'
export default {
  name: '',
  data () {
    return {

    }
  },
  computed: {
    ...mapState('rule', ['getChildrenFn', 'noticeList', 'page', 'openIds']),
    ...mapState('rule', {
      navList: 'leftNavList'
    }),
    ancestors () {
      // console.log(22234, this.page, this.navList)
      let breadCrumbs = []
      if (this.page === 'Notice') {
        if (this.openIds.length > 1) {
          this.setBreadCrumbs(this.navList, breadCrumbs)
        } else {
          breadCrumbs = [{
            name: '首页'
          }, {
            name: '最新公告'
          }]
        }
      } else {
        this.setBreadCrumbs(this.navList, breadCrumbs)
      }
      return breadCrumbs
    }
  },
  methods: {
    setBreadCrumbs (navList, breadCrumbs) {
      navList.forEach((item) => {
        if (this.openIds.includes(item.categoryId)) {
          breadCrumbs.push(item)
          if (item.children && item.children.length) {
            this.setBreadCrumbs(item.children, breadCrumbs)
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.crumbs-container {
  font-size: 12px;
  line-height: 14px;
  border-left: 2px solid #F10180;
  color: #333;
  margin-left: -10px;
  padding-left: 10px;
  .active {
    color: #999;
  }
}
</style>
